import { Heading, Pilcrow, Quote } from 'lucide-react';
import { useProjectStore } from '../../../state/projectStore';
import { useCurrentTarget } from './useCurrentTarget';
import { EmptyState } from '../../ui/EmptyState';
import { t } from '../../../i18n';
import type { TextElement } from '@fotoboek/domain';

function makeText(
  content: string,
  x: number,
  y: number,
  width: number,
  height: number,
  sizePt: number,
  fontFamily: string,
): TextElement {
  return {
    id: crypto.randomUUID(),
    type: 'text',
    x,
    y,
    width,
    height,
    rotation: 0,
    opacity: 1,
    zIndex: 0,
    locked: false,
    hidden: false,
    content,
    fontFamily,
    fontSizePt: sizePt,
    fontWeight: 400,
    fontStyle: 'normal',
    lineHeight: 1.3,
    letterSpacingEm: 0,
    align: 'left',
    color: '#1a1a1a',
    backgroundColor: null,
    autoHeight: true,
    verticalAlign: 'top',
  };
}

export function TextTab() {
  const target = useCurrentTarget();
  const addElement = useProjectStore((s) => s.addElement);

  if (!target) {
    return (
      <div className="left-panel-tab-body">
        <EmptyState title="Selecteer eerst een pagina." />
      </div>
    );
  }

  return (
    <div className="left-panel-tab-body">
      <button
        className="left-panel-action-btn"
        onClick={() => addElement(target, makeText('Titel', 20, 20, 160, 24, 28, 'Source Serif 4'))}
      >
        <Heading size={16} />
        {t('editor.text.addHeading')}
      </button>
      <button
        className="left-panel-action-btn"
        onClick={() =>
          addElement(
            target,
            makeText('Schrijf hier je tekst…', 20, 60, 160, 60, 13, 'Source Sans 3'),
          )
        }
      >
        <Pilcrow size={16} />
        {t('editor.text.addBody')}
      </button>
      <button
        className="left-panel-action-btn"
        onClick={() =>
          addElement(target, makeText('Onderschrift', 20, 170, 160, 18, 11, 'Source Sans 3'))
        }
      >
        <Quote size={16} />
        {t('editor.text.addCaption')}
      </button>
    </div>
  );
}
